import 'es6-symbol/implement';
// To ensure React and ReactDOM are exported, include them here manually
import React from 'react';
import ReactDOM, { render } from 'react-dom';

import ActionBar from './action-bar';
import Action from './action-bar/action';
import ActionList from './action-list';
import Alert from './alert';
import AvatarGroup from './avatars/group';
import AvatarOrg from './avatars/org';
import AvatarTeam from './avatars/team';
import AvatarUser from './avatars/user';
import Button from './buttons/button';
import ButtonRow from './buttons/button-row';
import Card from './card';
import CardMedia from './card/card-media';
import Checkbox from './forms/checkbox';
import CheckboxGroup from './forms/checkbox-group';
import CheckboxParentGroup from './forms/checkbox-parent-group';
import DataTable from './data-table';
import FormModifier from './forms/form-modifier';
import FormSection from './forms/form-section';
import Input from './forms/input';
import Legend from './legend';
import ParentCheckbox from './forms/parent-checkbox';
import Radio from './forms/radio';
import RadioGroup from './forms/radio-group';
import SearchInput from './forms/search-input';
import Textarea from './forms/textarea';
import Icon from './icon';
import KeyboardShortcut from './keyboard-shortcut';
import Link from './link';
import Modal from './modal';
import Note from './notifications/note';
import Notice from './notifications/notice';
import Overlay from './overlay';
import Toast from './notifications/toast';
import SelectMark from './select-mark';
import LookupMultiSelect from './selects/lookup-multi-select';
import LookupSelect from './selects/lookup-select';
import OptionSubtitle from './selects/option-subtitle';
import OptionTitle from './selects/option-title';
import SingleSelect from './selects/single-select';
import Spinner from './spinner';
import Environment from './theme/environment';
import Level from './theme/level';
import Tooltip from './tooltip';
import Headline from './type/headline';
import ItemTitle from './type/item-title';
import Subhead from './type/subhead';
import Text from './type/text';

export { ActionBar };
export { Action };
export { ActionList };
export { Alert };
export { AvatarGroup };
export { AvatarOrg };
export { AvatarTeam };
export { AvatarUser };
export { Button };
export { ButtonRow };
export { Card };
export { CardMedia };
export { Checkbox };
export { CheckboxGroup };
export { CheckboxParentGroup };
export { DataTable };
export { FormModifier };
export { FormSection };
export { Input };
export { Legend };
export { ParentCheckbox };
export { Radio };
export { RadioGroup };
export { SearchInput };
export { Textarea };
export { Icon };
export { KeyboardShortcut };
export { Link };
export { Modal };
export { Note };
export { Notice };
export { Overlay };
export { Toast };
export { SelectMark };
export { LookupMultiSelect };
export { LookupSelect };
export { OptionSubtitle };
export { OptionTitle };
export { SingleSelect };
export { Spinner };
export { Environment };
export { Level };
export { Tooltip };
export { Headline };
export { ItemTitle };
export { Subhead };
export { Text };

export { React };
export { ReactDOM };

export const renderHelper = (domElementId, Element, data) => {
  render(<Element {...data} />, document.getElementById(domElementId));
};



// WEBPACK FOOTER //
// ./src/index.js